{
  "filtersList": [
    {
      "name": "Ordena por",
      "value": "sort",
      "type": "select",
      "groupBy": "sort",
      "excludedCategories": [],
      "options": [
        {
          "label": "Ordena por",
          "checked": true,
          "value": "featured"
        },
        {
          "label": "Precio: Creciente",
          "checked": false,
          "value": "metaprice:asc"
        },
        {
          "label": "Precio: Descendente",
          "checked": false,
          "value": "metaprice:desc"
        },
        {
          "label": "Novedades",
          "checked": false,
          "value": "release_date"
        },
        {
          "label": "Orden alfabético: A-Z",
          "checked": false,
          "value": "title:asc"
        },
        {
          "label": "Orden alfabético: Z-A",
          "checked": false,
          "value": "title:desc"
        }
      ]
    },
    {
      "name": "",
      "value": "cf_kw_is_product_in_offer",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "Top ofertas",
          "checked": false,
          "value": "true"
        }
      ]
    },
    {
      "name": "Series",
      "value": "cf_kw_series",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "iO",
          "checked": false,
          "value": "separator_1"
        },
        {
          "label": "iO 10",
          "checked": false,
          "value": "IO10"
        },
        {
          "label": "iO 9",
          "checked": false,
          "value": "IO09"
        },
        {
          "label": "iO 8",
          "checked": false,
          "value": "IO08"
        },
        {
          "label": "iO 7",
          "checked": false,
          "value": "IO07"
        },
        {
          "label": "iO 6",
          "checked": false,
          "value": "IO06"
        },
        {
          "label": "iO 5",
          "checked": false,
          "value": "IO05"
        },
        {
          "label": "iO 4",
          "checked": false,
          "value": "IO04"
        },
        {
          "label": "iO 3",
          "checked": false,
          "value": "IO03"
        },
        {
          "label": "iO Ultimate Clean",
          "checked": false,
          "value": "IO_ULT"
        },
        {
          "label": "iO Gentle Clean",
          "checked": false,
          "value": "IO_GEN"
        },
        {
          "label": "iO Radiant White",
          "checked": false,
          "value": "IO_WHI"
        },
        {
          "label": "iO Specialised Clean",
          "checked": false,
          "value": "IO_ORTHO"
        },
        {
          "label": "Pro",
          "checked": false,
          "value": "separator_14"
        },
        {
          "label": "Pro 3",
          "checked": false,
          "value": "PRO"
        },
        {
          "label": "Otros recambios",
          "checked": false,
          "value": "separator_16"
        },
        {
          "label": "Cross Action",
          "checked": false,
          "value": "OTHER_CROSS"
        },
        {
          "label": "3D White",
          "checked": false,
          "value": "OTHER_3D"
        },
        {
          "label": "Interspace",
          "checked": false,
          "value": "OTHER_ORTHO"
        },
        {
          "label": "Sensitive",
          "checked": false,
          "value": "OTHER_SENSITIVE"
        }
      ]
    },
    {
      "name": "Características",
      "value": "cf_kw_characteristics",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "Tecnología",
          "checked": false,
          "value": "separator_1"
        },
        {
          "label": "Conexion con App via Bluetooth",
          "checked": false,
          "value": "FEAT_BT"
        },
        {
          "label": "Inteligencia artificial",
          "checked": false,
          "value": "FEAT_IA"
        },
        {
          "label": "Tecnología Magnética iO",
          "checked": false,
          "value": "FEAT_IO"
        },
        {
          "label": "Dentífrico",
          "checked": false,
          "value": "separator_5"
        },
        {
          "label": "Blanqueante",
          "checked": false,
          "value": "FEAT_BLANQUEANTE"
        },
        {
          "label": "Sensibilidad",
          "checked": false,
          "value": "FEAT_SENSIBILIDAD"
        },
        {
          "label": "Encías y Esmalte",
          "checked": false,
          "value": "FEAT_ENCIAS_ESMALTE"
        },
        {
          "label": "Antibacterias",
          "checked": false,
          "value": "FEAT_ANTIBAC"
        },
        {
          "label": "Regeneradora",
          "checked": false,
          "value": "FEAT_REGENERADORA"
        },
        {
          "label": "Multibeneficio",
          "checked": false,
          "value": "FEAT_MULTIBENEFICIO"
        },
        {
          "label": "Enjuague bucal",
          "checked": false,
          "value": "separator_12"
        },
        {
          "label": "Protección Profesional",
          "checked": false,
          "value": "FEAT_PROTECCION_PROFESIONAL"
        },
        {
          "label": "Limpieza profunda",
          "checked": false,
          "value": "FEAT_LIMPIEZA_PROFUNDA"
        },
        {
          "label": "Blanqueante",
          "checked": false,
          "value": "FEAT_BLANQUEANTE"
        },
        {
          "label": "Dientes fuertes",
          "checked": false,
          "value": "FEAT_DIENTES_FUERTES"
        }
      ]
    },
    {
      "name": "Tipo de cerdas",
      "value": "cf_kw_material",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "Para encías sensibles",
          "checked": false,
          "value": "ENCIAS_SENSIBLES"
        },
        {
          "label": "Estándar",
          "checked": false,
          "value": "STANDARD"
        }
      ]
    },
    {
      "name": "Tipo de producto",
      "value": "cf_kw_product_type",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "Cepillos eléctricos",
          "checked": false,
          "value": "CEPILLOS"
        },
        {
          "label": "Recambios",
          "checked": false,
          "value": "RECAMBIOS"
        },
        {
          "label": "Dentífrico",
          "checked": false,
          "value": "PT_DENTIFRICO"
        }
      ]
    },
    {
      "name": "Edad",
      "value": "cf_kw_ages",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "Niños desde 3 años",
          "checked": false,
          "value": "AGE_3"
        },
        {
          "label": "Niños desde 6 años",
          "checked": false,
          "value": "AGE_6"
        }
      ]
    },
    {
      "name": "Productos para una higiene bucal completa",
      "value": "cf_kw_concern",
      "type": "multi-select",
      "groupBy": "crit",
      "excludedCategories": [],
      "options": [
        {
          "label": "Dentífrico",
          "checked": false,
          "value": "DENTIFRICO"
        },
        {
          "label": "Enjuague bucal",
          "checked": false,
          "value": "ENJUAGUE"
        },
        {
          "label": "Hilo dental",
          "checked": false,
          "value": "HILO"
        },
        {
          "label": "Irrigador",
          "checked": false,
          "value": "IRRIGADOR"
        }
      ]
    }
  ]
}